import { LABEL_POSITIONS, VARIABLES } from '../constants';

const getLabelStyles = (elementBounds, indent, position, fullwidth) => {
  const { width, left } = elementBounds;
  const highlighterWidth = `calc(${Math.round(width)}px + ${indent} * 2 + ${
    VARIABLES.borderWidth
  } * 2)`;

  switch (position) {
    case LABEL_POSITIONS.centerBottom:
      return {
        maxWidth: fullwidth
          ? `calc(${Math.round(width + left * 2)}px - ${VARIABLES.borderWidth} * 2)`
          : highlighterWidth,
        left: `${Math.round(left + width / 2)}px`,
      };
    case LABEL_POSITIONS.rightBottom:
      return {
        maxWidth: fullwidth
          ? `calc(${Math.round(left + width)}px + ${VARIABLES.borderWidth})`
          : highlighterWidth,
        left: `calc(${Math.round(left + width)}px + ${indent} + ${VARIABLES.borderWidth})`,
      };
    case LABEL_POSITIONS.leftBottom:
    default:
      return {
        maxWidth: fullwidth
          ? `calc(100% - ${Math.round(left)}px + ${VARIABLES.borderWidth})`
          : highlighterWidth,
        left: `calc(${Math.round(left)}px - ${indent} - ${VARIABLES.borderWidth})`,
      };
  }
};

export default getLabelStyles;
